import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
// State
import { AppState } from '../../reducers';
import {
  selectCompanyNotificationsInStore,
  selectCompanyNotificationsPageLoading,
  selectCompanyNotificationsShowInitWaitingMessage,
} from '../_selectors/company-notification.selectors';

export class CompanyNotificationsDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectCompanyNotificationsPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(
      select(selectCompanyNotificationsShowInitWaitingMessage),
    );

    this.store
      .pipe(select(selectCompanyNotificationsInStore))
      .subscribe((response: QueryResultsModel) => {
        this.paginatorTotalSubject.next(response.totalCount);
        this.entitySubject.next(response.items);
      });
  }
}
